import Cookie from 'js-cookie';
import { takeEvery, fork, put } from 'redux-saga/effects';
import { SET_INTERMEDIATE_SEARCH_VIEW_MODE, SET_COMMITTED_SEARCH_VIEW_MODE, LOGOUT } from 'store/state/app/types';
import { setIntermediateSearchViewMode, setCommittedSearchViewMode } from 'store/state/app/actions';
import { SearchViewMode, SEARCH_VIEW_KEY } from 'components/list-view-switcher/constants';


function* intermediateSearchViewModeWorker({ payload }: ReturnType<typeof setIntermediateSearchViewMode>) {
  yield put(setCommittedSearchViewMode(payload));
}

function* logoutWorker() {
  yield put(setIntermediateSearchViewMode(SearchViewMode.Grid));
}

export function* intermediateSearchViewWatcher() {
  yield takeEvery(SET_INTERMEDIATE_SEARCH_VIEW_MODE, intermediateSearchViewModeWorker);
}


function* committedSearchViewModeWorker({ payload }: ReturnType<typeof setIntermediateSearchViewMode>) {
  Cookie.set(SEARCH_VIEW_KEY, payload);
}

export function* committedSearchViewWatcher() {
  yield takeEvery(SET_COMMITTED_SEARCH_VIEW_MODE, committedSearchViewModeWorker);
}

export function* logoutWatcher() {
  yield takeEvery(LOGOUT, logoutWorker);
}

export function* searchViewWatcher() {
  yield fork(intermediateSearchViewWatcher);
  yield fork(committedSearchViewWatcher);
  yield fork(logoutWatcher);
}
